var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("数据查询")]),
            ]),
            _vm.query.warId == -1
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/logisticsSystem/productData" } } },
                  [_c("div", { staticClass: "div1" }, [_vm._v("产品数据")])]
                )
              : _vm._e(),
            _vm.query.warId == 1
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/logisticsSystem/warehouseData" } } },
                  [_c("div", { staticClass: "div1" }, [_vm._v("仓库数据")])]
                )
              : _vm._e(),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("产品数据详情")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "query" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("查询商品")]),
        _c(
          "el-form",
          { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
          [
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "时间" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    size: "mini",
                    type: "month",
                    placeholder: "选择日期",
                    format: "yyyy-MM",
                    "value-format": "yyyy-MM",
                    "picker-options": _vm.pickerOptions,
                  },
                  model: {
                    value: _vm.form.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "date", $$v)
                    },
                    expression: "form.date",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "formItem", attrs: { label: "仓库" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", size: "mini" },
                    on: { change: _vm.foreceUpdate },
                    model: {
                      value: _vm.form.warId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "warId", $$v)
                      },
                      expression: "form.warId",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-right": "0px" },
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.params },
              },
              [_vm._v("搜索出库数据")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "middle" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("产品信息")]),
                  ]),
                  _c("el-image", {
                    staticStyle: { width: "100px", height: "100px" },
                    attrs: { src: _vm.img(_vm.tableData.image), fit: "cover" },
                  }),
                  _c("div", [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("商品名称:")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.title)),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("商品品牌: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.brandName)),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("商品单价: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.sellPrice)),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("出库排行: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.sellPrice)),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("总库存: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.tableData.quantityStock) + " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("出库总数: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.outNumber)),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("出库总额: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.price)),
                        ]),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("span", [_vm._v("入库总数: ")]),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.tableData.inNumber)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticStyle: { position: "relative" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "absolute",
                            right: "0",
                            bottom: "0",
                          },
                        },
                        _vm._l(_vm.tableData.warehouses, function (item) {
                          return _c("div", { staticClass: "text" }, [
                            _c("span", [_vm._v(_vm._s(item.warName) + ": ")]),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v(_vm._s(item.number))]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _c("el-col", { staticClass: "right", attrs: { span: 16 } }, [
              _c("div", {
                staticStyle: { width: "100%", height: "450px" },
                attrs: { id: "chartLineBox" },
              }),
              _c("div", { staticClass: "lineBoxText" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.tableData.month
                        ? _vm.tableData.month.substring(5, 7)
                        : new Date().getMonth()
                    ) +
                    "月 "
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "title" }, [_vm._v("销售排行")]),
      _c(
        "div",
        { staticClass: "context" },
        _vm._l(_vm.tableData.salesRanking, function (item) {
          return _c("div", { key: item.label, staticClass: "contextBd" }, [
            _c("span", { staticClass: "top" }, [_vm._v(_vm._s(item.label))]),
            _c("span", { staticClass: "bottom" }, [_vm._v(_vm._s(item.value))]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }